import React, { PropTypes } from 'react';

import {NitroIcon} from 'nitro-components';
import styled from 'styled-components';

const Details = styled.section`
  margin-left: 40px;
`;

const VehicleDetails = styled.span`
  float: right;
  text-align: right;
  margin-right: 10px;
  font-size: 12px;
  font-family: ${props => props.theme.font.bold};
  color: ${props => props.theme.color.base2};
  white-space: nowrap;
  cursor: pointer;
`;

const VehicleInfo = styled.div`
  margin-bottom: 10px;
`;
const Driver = styled.span`
  color: ${props => props.theme.color.base3};
`;
const Name = styled.span`
  float: left;
  color: ${props => props.theme.color.base1};
  font-family: ${props => props.theme.font.bold};
`;
const Registration = styled.span`
  margin-left: 20px;
`;

const CostCenterDiv = styled.div`
  margin-right: 80px;
  color: ${props => props.theme.color.base3};
  font-size: 12px;
`;

const VehicleListDetails = ({ vehicle, action }) => {
  const { MakeModel, RegistrationNumber, DriverFirstName, DriverSurname, CompanyName, CostCenter } = vehicle;

  const handleClick = () => {
    action(vehicle);
  };

  return (
    <Details>
      <VehicleInfo>
        <Name>{`${MakeModel}`}</Name>
        <Registration>{RegistrationNumber}</Registration>
      </VehicleInfo>
      <VehicleInfo>
        <Driver>{`${DriverFirstName} ${DriverSurname}`}</Driver>
        <VehicleDetails onClick={handleClick}>
          {'Details'}
          <NitroIcon alignment name="arrow-right" size={8} left={8} />
        </VehicleDetails>
      </VehicleInfo>
      <CostCenterDiv>{CompanyName}</CostCenterDiv>
      { CostCenter !== null &&  <CostCenterDiv>{CostCenter}</CostCenterDiv> }
    </Details>
  );
};

VehicleListDetails.propTypes = {
  vehicle: PropTypes.object,
  action: PropTypes.func
};

export default VehicleListDetails;



// WEBPACK FOOTER //
// ./src/features/relocations/vehicle/components/VehicleListDetails.js